import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@repo/ui-primitives/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@repo/ui-primitives/dialog';
export function AlphaAcceptModal(param) {
    let { open, onLogOut, onConfirm, onChangeOrg } = param;
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        children: /*#__PURE__*/ _jsxs(DialogContent, {
            showCloseButton: false,
            className: "flex flex-col p-10 border-none bg-popover min-w-3xl gap-6",
            "data-e2e": "ACCEPT_MODAL",
            children: [
                /*#__PURE__*/ _jsx(DialogHeader, {
                    children: /*#__PURE__*/ _jsx(DialogTitle, {
                        className: "text-[32px] font-semibold leading-[120%] text-center",
                        children: "Zephyr Cloud"
                    })
                }),
                /*#__PURE__*/ _jsx(DialogDescription, {
                    className: "text-lg font-medium text-center text-foreground my-4",
                    children: "Zephyr Cloud's software is provided on an 'as is' and 'as available' basis without warranties of any kind, either express or implied, including, but not limited to, warranties of merchantability, fitness for a particular purpose, or non-infringement. We expressly disclaim any warranty regarding the reliability, accuracy, timeliness, usefulness, or completeness of any information or content regarding the software"
                }),
                /*#__PURE__*/ _jsxs(DialogFooter, {
                    className: "flex !flex-col justify-center items-center gap-6",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex w-full gap-14",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "destructive",
                                    className: "flex-1",
                                    onClick: onLogOut,
                                    "data-e2e": "ACCEPT_MODAL__LOGOUT_BUTTON",
                                    children: "Log out"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "default",
                                    className: "flex-1",
                                    onClick: onConfirm,
                                    "data-e2e": "ACCEPT_MODAL__CONFIRM_BUTTON",
                                    children: "Accept"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "underline underline-offset-4",
                            onClick: onChangeOrg,
                            children: "Change organization"
                        })
                    ]
                })
            ]
        })
    });
}
